export class SelectorError extends Error {
  constructor(message?: string) {
    super(`[selector]: ${message}`)
    Object.setPrototypeOf(this, SelectorError.prototype)
  }
}
